import React, { Component } from "react";
import "../style/DashboardEditor.css";
import { isEqual } from "lodash";
import axios from "axios";
// import deleteMotet from "../services/deleteMotet";
import FileUploader from "./FileUploader";
import keys from "../config";
export class DashboardEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPiecename: "",
      newComposer: "",
      newCategory: "",
      newCategoryList: "",
      newAuthFile: null,
      newUnAuthFile: null,
      confirmDelete: false,
      serverResponse: null,
      loadSpinner: false
    };
    this.renderInputs = this.renderInputs.bind(this);
    this.addToList = this.addToList.bind(this);
    this.removeFromList = this.removeFromList.bind(this);
    this.newAuthFile = this.newAuthFile.bind(this);
    this.newUnAuthFile = this.newUnAuthFile.bind(this);
  }
  componentDidMount() {
    const { pieceName, composer } = this.props.pdf;
    this.setState({
      newCategoryList: [...this.props.pdf.category.split(",")],
      // temporarily values
      newPiecename: pieceName,
      newComposer: composer
    });
    const isFirefox = typeof InstallTrigger !== "undefined";
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!isFirefox && !isSafari) {
      const body = document.querySelectorAll("body")[0];
      body.classList.add("freeze");
    }
  }
  addToList(e) {
    if (e.key === "Enter") {
      this.setState(prevState => {
        return {
          newCategory: "",
          newCategoryList: [
            ...prevState.newCategoryList,
            this.state.newCategory
          ]
        };
      });
    }
  }
  removeFromList(el) {
    this.setState(prevState => {
      return {
        newCategoryList: [
          ...prevState.newCategoryList.filter(item => item !== el)
        ]
      };
    });
  }
  newAuthFile(file) {
    this.setState({
      newAuthFile: file
    });
  }
  newUnAuthFile(file) {
    this.setState({
      newUnAuthFile: file
    });
  }
  async handleSubmit(method) {
    if (method === "delete") {
      this.setState({
        loadSpinner: true
      });
      const headers = {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      };
      const url = keys.deleteObjectUrl;
      const data = {
        pdfToDelete: this.props.pdf
      };
      const result = await axios.post(url, data, headers);
      if (result.data) {
        window.location.reload();
        return;
      } else {
        // const serverResponse = result.message;
        return this.setState({
          serverResponse:
            "Something went wrong in DashboardEditor.js, let Sam know"
        });
      }
    }
    // console.log("Updating this file,", this.props.pdf);
    const {
      newCategoryList,
      newComposer,
      newPiecename
      // newAuthFile,
      // newUnAuthFile
    } = this.state;
    const originalCategories = [...this.props.pdf.category.split(",")];
    let modifiedTags = originalCategories;
    let modifiedComposer = this.props.pdf.composer;
    let modifiedPiecename = this.props.pdf.pieceName;
    // let modifiedAuthFile = this.props.pdf.filename;
    // let modifiedUnAuthFile = this.props.pdf.unAuthFilename;
    if (!isEqual(originalCategories, newCategoryList)) {
      modifiedTags = newCategoryList;
    }
    if (this.state.newComposer.length > 1) {
      modifiedComposer = newComposer;
    }
    if (this.state.newPiecename.length > 1) {
      modifiedPiecename = newPiecename;
    }
    // if (this.state.newAuthFile) {
    //   modifiedAuthFile = newAuthFile;
    // }
    // if (this.state.newUnAuthFile) {
    //   modifiedUnAuthFile = newUnAuthFile;
    // }
    const headers = {
      headers: {
        Authorization: localStorage.getItem("token")
      }
    };
    let formData = new FormData();

    // if we're just editing metadata
    formData.append("category", modifiedTags);
    formData.append("composer", modifiedComposer);
    formData.append("pieceName", modifiedPiecename);
    formData.append("filename", this.props.pdf.filename);
    formData.append("unAuthFilename", this.props.pdf.unAuthFilename);
    if (this.state.newAuthFile) {
      // if we're replacing auth file
      formData.append("file", this.state.newAuthFile);
    }
    if (this.state.newUnAuthFile) {
      // if we're replacing unauth file
      formData.append("unAuthFile", this.state.newUnAuthFile);
    }
    const url = keys.updateObjectUrl;
    const res = await axios.post(url, formData, headers);
    if (res.data) {
      window.location.reload();
    } else {
      this.setState({
        serverResponse:
          "Something went wrong with DashboardEditor.js, let Sam know this"
      });
    }
  }
  renderInputs() {
    const { pieceName, composer } = this.props.pdf;
    return (
      <div>
        <div className="dashboard-input-holder">
          <label
            className={
              this.state.newPiecename
                ? "dashboard-input-helper-active"
                : "dashboard-input-helper"
            }
          >
            Edit piece name
          </label>
          <input
            className="sign-input dashboard-input"
            onChange={e => this.setState({ newPiecename: e.target.value })}
            placeholder={pieceName}
            type="text"
            value={this.state.newPiecename}
          />
        </div>
        <div className="dashboard-input-holder">
          <label
            className={
              this.state.newComposer
                ? "dashboard-input-helper-active"
                : "dashboard-input-helper"
            }
          >
            Edit composer
          </label>
          <input
            className="sign-input dashboard-input"
            onChange={e => this.setState({ newComposer: e.target.value })}
            placeholder={composer}
            type="text"
            value={this.state.newComposer}
          />
        </div>
        <div className="dashboard-input-holder">
          <label
            className={
              this.state.newCategory
                ? "dashboard-input-helper-active"
                : "dashboard-input-helper"
            }
          >
            A new tag (press enter)
          </label>
          <input
            className="sign-input dashboard-input"
            onChange={e => this.setState({ newCategory: e.target.value })}
            onKeyPress={this.addToList}
            placeholder="Add a new tag and hit enter"
            type="text"
            value={this.state.newCategory}
          />
        </div>
        <div className="category-boxes">
          {this.state.newCategoryList &&
            this.state.newCategoryList.map(el => (
              <div
                onClick={e => this.removeFromList(el)}
                key={el + "mok"}
                className="category-item"
              >
                {el}
              </div>
            ))}
        </div>
        <span className="hint">Click a tag to remove it</span>
        <div className="dashboard-fileupload">
          <FileUploader
            sendFileData={this.newAuthFile}
            text={"Upload a complete file"}
          />

          <FileUploader
            sendFileData={this.newUnAuthFile}
            text={"Upload a one-page file"}
          />
        </div>
      </div>
    );
  }

  render() {
    const { newPiecename, newComposer } = this.state;
    const { pieceName, composer } = this.props.pdf;
    return (
      <div className="dashboard-editor-background">
        <button
          onClick={e => this.props.closeEditor()}
          className="dashboard-editor-exit"
        >
          <span>✖</span>
        </button>
        <div className="dashboard-editor">
          {this.renderInputs()}
          <div className="summary">
            <h4>This will be saved to the database:</h4>
            <p>
              Title:&nbsp;
              <span className="changed">
                {newPiecename.length < 1 ? String(pieceName) : newPiecename}
              </span>
            </p>
            <p>
              Composer:&nbsp;
              <span className="changed">
                {newComposer.length < 1 ? String(composer) : newComposer}
              </span>
            </p>
            {/* <p>
              Tags:&nbsp;
              <span className="changed">
                {this.state.newCategoryList.length < 1
                  ? "No tags"
                  : String(
                      this.state.newCategoryList.reduce((p, c) => p + ", " + c)
                    )}
              </span>
            </p> */}
            <p>
              File for authenticated users:&nbsp;
              <span className="changed">
                {this.state.newAuthFile
                  ? String(this.state.newAuthFile.name)
                  : String(this.props.pdf.filename)}
              </span>
            </p>
            <p>
              File for unauthenticated users:&nbsp;
              <span className="changed">
                {this.state.newUnAuthFile
                  ? String(this.state.newUnAuthFile.name)
                  : String(this.props.pdf.unAuthFilename)}
              </span>
            </p>
            {this.state.serverResponse && (
              <p className="server-response">{this.state.serverResponse}</p>
            )}
            {!this.state.loadSpinner && (
              <div className="dashboard-editor-btn-holder">
                <button
                  onClick={e => this.handleSubmit("modify")}
                  className="dashboard-editor-btn"
                >
                  Submit changes
                </button>
                {this.state.confirmDelete ? (
                  <button
                    onClick={e => this.handleSubmit("delete")}
                    className="dashboard-editor-btn confirm-delete"
                  >
                    ARE YOU SURE?!
                  </button>
                ) : (
                  <button
                    onClick={e => this.setState({ confirmDelete: true })}
                    className="dashboard-editor-btn delete"
                  >
                    Delete motet
                  </button>
                )}
                {this.state.loadSpinner &&
                  !this.state.serverResponse && (
                    <div>
                      <div className="spinner-holder">
                        <div className="circle">
                          <div className="sub-circle" />
                        </div>
                      </div>
                      <div style={{ textAlign: "center" }}>Loading</div>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardEditor;



// WEBPACK FOOTER //
// ./src/components/DashboardEditor.js